import { Control } from "ol/control.js";
import Draw from "ol/interaction/Draw.js";
import { Circle as CircleStyle, Fill, Stroke, Style } from "ol/style.js";
import { Vector as VectorSource } from "ol/source.js";
import { Vector as VectorLayer } from "ol/layer.js";

class Circulo extends Control {
  constructor(opt_options) {
    const options = opt_options || {};
    const button = document.createElement("button");
    const tipLabel =
      options.tipLabel !== undefined ? options.tipLabel : "Dibujo Circulo";
    button.title = tipLabel;
    button.innerText = "◯";

    const element = document.createElement("div");
    element.className = "dibujo-control-circulo ol-unselectable ol-control";
    element.appendChild(button);

    super({ element: element, target: options.target });
    this.vectorSource = new VectorSource();

    this.draw = null;
    this.measureTooltipElement = null;
    this.helpTooltipElement = null;
    this.active = false;
    //agregado para poder desactivar global
    this.onActivate = options.onActivate;

    button.addEventListener("click", this.toggleMeasurement.bind(this), false);
  }

  toggleMeasurement() {
    if (!this.active) {
      // agregado para poder desactivar global
      if (this.onActivate) this.onActivate(this);

      this.getMap().addLayer(
        new VectorLayer({
          source: this.vectorSource,
          style: new Style({
            fill: new Fill({ color: "rgba(255, 255, 255, 0.2)" }),
            stroke: new Stroke({ color: "#3366FF", width: 2 }),
            image: new CircleStyle({
              radius: 7,
              fill: new Fill({ color: "#3366FF" }),
            }),
          }),
        })
      );
      //this.getMap().addLayer(this.vectorLayer);
      this.addInteraction();
      this.active = true;
      this.element.classList.add("activo");
    } else {
      // this.getMap().removeLayer(this.vectorLayer);
      this.getMap().removeInteraction(this.draw);
      this.element.classList.remove("activo");

      // this.vectorSource.clear();

      // this.draw = null;
      // this.measureTooltipElement = null;
      // this.helpTooltipElement = null;

      // const measureElements = document.querySelectorAll(
      //   ".ol-tooltip.ol-tooltip-static"
      // );
      // console.log(measureElements);
      // measureElements.forEach((element) => {
      //   element.remove();
      // });
      this.active = false;
    }
  }
  addInteraction() {
    const value = "Circle";
    if (value !== "None") {
      this.draw = new Draw({
        source: this.vectorSource,
        type: "Circle",
        freehand: true,
      });

      this.getMap().addInteraction(this.draw);
    }
    //evento al estar activo, y hacer keydown escape sacar activo
    window.addEventListener("keydown", (e) => {
      if (e.code == "Escape") {
        console.log("escale");
        //this.getMap().removeLayer(this.vectorLayer);
        //this.getMap().removeInteraction(this.draw);
        //this.element.classList.remove("activo");

        //this.vectorSource.clear();
        //this.active = false;

        this.getMap().removeInteraction(this.draw);
        this.element.classList.remove("activo");
      }
    });
  }
  desactivar() {
    this.getMap().removeInteraction(this.draw);
    this.element.classList.remove("activo");
    this.active = false;
  }
}

export default Circulo;
